import { Analytics, getAnalytics } from 'firebase/analytics';
import { FirebaseApp } from 'firebase/app';

export class FirebaseAnalytics {
    private static instance: FirebaseAnalytics;
    private analytics: Analytics;
    private constructor(firebaseApp: FirebaseApp) {
        this.analytics = getAnalytics(firebaseApp);
    }

    public static getInstance(firebaseApp: FirebaseApp): FirebaseAnalytics {
        if (!FirebaseAnalytics.instance) {
            FirebaseAnalytics.instance = new FirebaseAnalytics(firebaseApp);
        }
        return FirebaseAnalytics.instance;
    }

    // Add analytics methods here
    //TODO check if there is something usefull here
}
